import React, { useState } from 'react';

// CanvasGuide: a dismissible overlay that walks new users through the
// workflow canvas. It is shown once per workflow and stored in localStorage
// so returning users skip it.
//
// Props:
//   workflow — the current workflow object; guide is shown only for empty graphs.
//   onComplete — callback when the user dismisses the guide.
export default function CanvasGuide({ workflow, onComplete }) {
  const id = workflow?.id || 'unknown';
  const storageKey = `analytics-guide-seen-${id}`;
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(storageKey));

  if (dismissed || (workflow?.graph && workflow.graph.nodes.length > 0)) {
    return null;
  }

  return (
    <div className="canvas-guide-overlay" onClick={handleDismiss}>
      <div className="canvas-guide-card" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="canvas-guide-close"
          onClick={() => {
            localStorage.setItem(storageKey, '1');
            setDismissed('1');
            onComplete?.();
          }}
          aria-label="Dismiss guide"
        >
          <span className="material-symbols-rounded">close</span>
        </button>

        <div className="canvas-guide-step">
          <div className="canvas-guide-step-number">Step 1 of 3</div>
          <h3 className="canvas-guide-title">Add your first node</h3>
          <p className="canvas-guide-text">
            Click <strong>Data source</strong> in the palette above the canvas to start. Choose an
            entity like <em>Grave</em> or <em>Skeleton</em>.
          </p>
        </div>

        <div className="canvas-guide-step">
          <div className="canvas-guide-step-number">Step 2 of 3</div>
          <h3 className="canvas-guide-title">Connect the nodes</h3>
          <p className="canvas-guide-text">
            Drag from the <strong>● circle</strong> on the right of a node to the left side of the
            next node. This creates a data pipeline.
          </p>
        </div>

        <div className="canvas-guide-step">
          <div className="canvas-guide-step-number">Step 3 of 3</div>
          <h3 className="canvas-guide-title">Configure &amp; run</h3>
          <p className="canvas-guide-text">
            Click any node to open its settings in the inspector. Add a<strong> Chart</strong> or{' '}
            <strong>Table</strong> node as your output, then hit <strong>Run</strong> at the top.
          </p>
        </div>

        <button
          type="button"
          className="btn btn-primary canvas-guide-start"
          onClick={() => {
            localStorage.setItem(storageKey, '1');
            setDismissed('1');
            onComplete?.();
          }}
        >
          Got it — start building
        </button>
      </div>
    </div>
  );

  function handleDismiss() {
    localStorage.setItem(storageKey, '1');
    setDismissed('1');
    onComplete?.();
  }
}
